module.exports = __webpack_public_path__ + "img/privacy.2cbe5a5e.png";